// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {AllnewsScreenLayout} from 'app_components/screens/landing/allnews'
// @end

// @ADD Component types
interface IAllnewsScreenProps {}
interface IAllnewsScreenState {}

class AllnewsScreen extends Component<IAllnewsScreenProps, IAllnewsScreenState> {

  render() {
    return(
      <AllnewsScreenLayout/>
    )
  }
}

export default AllnewsScreen
